import { get } from "./Client";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";


export function useGetDevices() {
	let project = useSelector(store => store.session.project);
	let params = project ? {pid:project.id} : null;
	const {status, data, error} = useQuery(['radarpestDevices', params], () =>
		get(`radarpest/device`, {params}),
		{enabled: !!project}
	);
	return {status, devices: data || [], error};
}

export function useGetDevice(deviceId) {
	const {status, data, error} = useQuery(['radarpestDevices', deviceId], () =>
		get(`radarpest/device/${deviceId}`),
		{enabled: !!deviceId}
	);
	return {status, device: data, error};
}


export function useGetInstallations() {
	let project = useSelector(store => store.session.project);
	let params = project ? {pid:project.id} : null;
	const {status, data, error} = useQuery(['radarpestInstallations', params], () =>
		get(`radarpest/installation`, {params}), {
			enabled: !!project,
			select: data => data.filter(a => !a.archived)
		}
	);
	return {status, installations: data || [], error};
}

export function useGetDeviceInstallations(deviceId) {
	let params = {did: deviceId}
	const {status, data, error} = useQuery(['radarpestInstallations', params], () =>
		get(`radarpest/installation`, {params}),
		{enabled: !!deviceId}
	);
	return {status, installations: data || [], error};
}


export function getDeviceTodayData(deviceId) {
	return get(`radarpest/deviceData/${deviceId}/today`)
}

export function getDeviceWeeklyData(deviceId) {
	return get(`radarpest/deviceData/${deviceId}/week`)
}

export function getDeviceMonthlyData(deviceId) {
	return get(`radarpest/deviceData/${deviceId}/month`)
}

export function getDeviceCustomData(deviceId, start, end) {
	return get(`radarpest/deviceData/${deviceId}/custom`, { params: { start, end } })
}


export function getInstallationTodayData(installationId) {
	return get(`radarpest/installationData/${installationId}/today`)
}

export function getInstallationWeeklyData(installationId) {
	return get(`radarpest/installationData/${installationId}/week`)
}

export function getInstallationMonthlyData(installationId) {
	return get(`radarpest/installationData/${installationId}/month`)
}

export function getInstallationCustomData(installationId, start, end) {
	return get(`radarpest/installationData/${installationId}/custom`, { params: { start, end } })
}
